import { render, staticRenderFns } from "./CoinRotateTopIcon.vue?vue&type=template&id=2d6efb1f&"
import script from "./CoinRotateTopIcon.vue?vue&type=script&lang=ts&"
export * from "./CoinRotateTopIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports